import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {Logo} from "../logo/Logo";
import {Col, Row} from "antd";
import Frame from "../../assets/images/file-upload-frame.svg";
import '../free-account-landing/freeAccountLanding.css';



export class Evaluation extends Component {
        
  render() {
    const { intl } = this.props;        
    const LINK_TO_BUNKEY_LATAM = "https://bunkeylatam.com/";

    return (
        <div
          style={{
            background: '#F5F5F5',
            height: '100vh',
          }}>
          {/* floating bubbles */}
          <ul id="shape">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <Row type={'flex'} justify={'center'} style={{ height: '10vh', alignItems: "center" }} span = {20}>
            <Col xxl={14} xl={14} lg={14} md={20} sm={20} xs={20}>
              <div
                style = {{
                  width: '100%'
                }}
              >
                <Logo 
                  onClick = {() => {
                    window.open(LINK_TO_BUNKEY_LATAM, "_blank")
                  }}
                />
              </div>
            </Col>            
          </Row>          
          <Row
            type={'flex'}
            justify={'center'}
            align={'middle'}
            style={{ height: '90vh', }}
          >
            <Col xxl={10} xl={10} lg={10} md={20} sm={20} xs={20}>
            <div style={{ fontSize: 60, fontWeight: 700, lineHeight: '60px', marginBottom: 30, color: '#3598CD' }}>{intl.formatMessage({ id: 'evaluation1' })}
              <span> {intl.formatMessage({ id: 'evaluation2' })}</span> {intl.formatMessage({ id: 'evaluation3' })}
            </div>
              
            </Col>
            <Col xxl={10} xl={10} lg={10} md={20} sm={20} xs={20}>
              <img src={Frame} alt="back file charges" width={'100%'} />
            </Col>
          </Row>          
        </div>
      )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Evaluation)))